import { DOCUMENT } from '@angular/common';
import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { SessaoService } from '../services/sessao.service';
import { SessaoStore } from '../store/sessao.store';
import { TRATAR_401_SESSAO } from './sessao-http-context';

export const autenticacaoInterceptor: HttpInterceptorFn = (req, next) => {
  const document = inject(DOCUMENT);
  let destinoApi = false;
  let abertura = false;
  try {
    const base = new URL(environment.apiUrl || '/', document.baseURI);
    const destino = new URL(req.url, document.baseURI);
    const caminhoApi = `${base.pathname.replace(/\/$/, '')}/api`;
    destinoApi = destino.origin === base.origin
      && (destino.pathname === caminhoApi || destino.pathname.startsWith(`${caminhoApi}/`));
    abertura = req.method === 'POST' && destino.pathname.replace(/\/$/, '') === `${caminhoApi}/sessoes`;
  } catch { /* URLs externas ou inválidas não recebem credenciais. */ }
  if (!destinoApi || abertura) return next(req);

  const store = inject(SessaoStore);
  const sessao = inject(SessaoService);
  const versao = store.versaoSessao;
  const token = store.token();
  const requisicao = req.clone({
    context: req.context.set(TRATAR_401_SESSAO, true),
    ...(token ? { setHeaders: { Authorization: `Bearer ${token}` } } : {})
  });
  return next(requisicao).pipe(
    tap(event => {
      if (event instanceof HttpResponse) {
        const novoToken = event.headers.get('X-Sessao-Token');
        if (novoToken && token) store.atualizarToken(novoToken, versao);
      }
    }),
    catchError((erro: HttpErrorResponse) => {
      const novoToken = erro.headers?.get('X-Sessao-Token');
      if (novoToken && token && erro.status !== 401) store.atualizarToken(novoToken, versao);
      if (erro.status === 401 && store.versaoSessao === versao) sessao.encerrarSessao();
      return throwError(() => erro);
    })
  );
};
